export default undefined; // this makes slate to fall back to browser dom parser
//# sourceMappingURL=parseHtml.browser.js.map